import noBlogImage from "../assets/no-blog-image.webp";
import MainContainer from "./MainContainer";
import TitleTextSection from "./TitelTextSection";
import ShowMoreLink from "./ShowMoreLink";
import Badge from "./Badge";

const PostRow = ({ item, type }) => {
  const postedByType = String(item?.posted_by_type || "").toLowerCase();
  const postedByBasePath = ["organizer", "organiser", "organization"].includes(
    postedByType,
  )
    ? "/orgs"
    : "/music";
  const postedByUrl = `${postedByBasePath}/${item.posted_by_slug}`;
  const itemUrl = `/music/${item.posted_by_slug}/blog/${item.slug}`;

  return (
    <a
      href={itemUrl}
      className="flex gap-4 border border-white/10 rounded-2xl bg-[#131313] overflow-hidden hover:bg-neutral-900/40 hover:border-white/20 transition-all duration-300 hover:scale-[1.01] shadow-md"
    >
      <div className="w-32 sm:w-48 shrink-0 relative overflow-hidden">
        <div className="absolute top-2 right-2 z-10">
          <Badge
            text={type}
            type={type === "Blogg" ? "post-blog" : "post-news"}
          />
        </div>
        <img
          className="w-full h-full object-cover"
          src={item.image_main || noBlogImage}
          alt={item.title}
        />
      </div>
      <div className="flex flex-col justify-between py-4 pr-4 overflow-hidden flex-1">
        <div>
          <h4 className="font-extrabold text-base sm:text-lg text-white uppercase tracking-wide line-clamp-2 leading-snug">
            {item.title}
          </h4>
          <p className="text-xs text-stone-400 line-clamp-2 mt-1.5 leading-relaxed">
            {item.content_ingress}
          </p>
        </div>
        <div className="flex justify-between items-center mt-3 pt-2 border-t border-white/5">
          <p className="text-[10px] text-stone-400">
            Av:{" "}
            <span
              className="font-bold text-white hover:text-[#0047ff] transition-colors"
            >
              {item.posted_by_name}
            </span>
          </p>
          <p className="text-[10px] text-stone-500">{item.created_at}</p>
        </div>
      </div>
    </a>
  );
};

const ListBlogpostsSection = ({ listName, newsItems, blogItems, subtitle }) => {
  return (
    <>
      <MainContainer noTopPadding={false}>
        <div className="pb-4">
          <div className="sm:py-4 flex justify-between items-center mb-2">
            <TitleTextSection title={listName} subtitle={subtitle} />
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            {newsItems?.length > 0 && (
              <div className="flex flex-col gap-4">
                <div className="flex justify-between items-center px-1">
                  <h3 className="text-xs font-bold text-blue-500 uppercase tracking-wider">
                    Nyheter
                  </h3>
                  <ShowMoreLink href="/news" />
                </div>
                {newsItems.map((item, index) => (
                  <PostRow key={index} item={item} type="Nyhet" />
                ))}
              </div>
            )}
            {blogItems?.length > 0 && (
              <div className="flex flex-col gap-4">
                <div className="flex justify-between items-center px-1">
                  <h3 className="text-xs font-bold text-blue-500 uppercase tracking-wider">
                    Blogginlägg
                  </h3>
                  <ShowMoreLink href="/blogs" />
                </div>
                {blogItems.map((item, index) => (
                  <PostRow key={index} item={item} type="Blogg" />
                ))}
              </div>
            )}
          </div>
        </div>
      </MainContainer>
    </>
  );
};

export default ListBlogpostsSection;
